import React, { memo } from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const GOOGLE_SVG_URL =
  "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg";

export default memo(({ className }) => (
  <SvgIcon
    component={() => <img className={className} src={GOOGLE_SVG_URL} alt="" />}
  />
));
